import React from "react";


const Todolist = (props) => {
    
    return(
        <>
        <li>
        <div className="align-items-center d-flex mb-3">
        <div> {props.text}</div>
        <div className="ms-2">
        <button 
        className="btn btn-danger" 
        onClick={()=>{
            props.onSelect(props.id)
        }}>x</button></div></div>
        </li>
    </>)
}
export default Todolist;